module.exports = __webpack_public_path__ + "img/satellite.80d8e04e.png";